import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="m53.89,26.53l-9.15,0c-0.46,0 -0.83,0.37 -0.83,0.82l0,16.69c0.12,3.97 -0.07,8.68 -0.56,9.49c-0.04,0.05 -0.07,0.1 -0.1,0.16c-0.59,1.22 -2.56,2.48 -4.82,2.48c-2.35,0 -5.12,-2 -5.92,-4.28a0.83,0.82 0 0 0 -1.04,-0.52l-7.6,2.35c-0.39,0.12 -0.63,0.51 -0.57,0.91c0,0.03 0.01,0.05 0.01,0.07c0.86,6.44 7.04,10.77 15.4,10.77c8.37,0 14.55,-4.33 15.41,-10.77c0.01,-0.04 0.01,-0.07 0.02,-0.11c0.58,-5.5 0.59,-10.52 0.59,-10.57l0,-16.66c0.01,-0.45 -0.36,-0.82 -0.82,-0.82z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
